module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00459.cc50b256.jpg";